// extracted by mini-css-extract-plugin
export default {"music-card-list":"MusicShelfList_music-card-list__AQDHp","music-card-carousel-list":"MusicShelfList_music-card-carousel-list__BEf-J","slider":"MusicShelfList_slider__evjVe"};